<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof49">
<p class="para2"><span class="bold">Order of St. Alexander of Neva</span> (<em class="italic">Orden Sv. Aleksandra Nevskago</em>) was set up by Empress Catherine I in 1725. It was named after Prince Alexander of Novgorod, who crushed the Swedes and Teutonic Crusaders (1240-1241). The order became the third highest award in the Russian Empire. Although it did not have classes, there were additions to this award that enhanced its prestige. After receiving the original award, the recipient could earn swords, diamond signs, and diamond swords to add to the Order. From 1800 to 1825, Emperor Alexander conferred more than 250 Orders of St. Alexander of Neva, including 48 during the Napoleonic Wars from 1812 to 1814.</p>
<p class="para2"><em class="italic">Motto:</em> “For Labor and Motherland” (<em class="italic">za trudy i otechestvo</em>)</p>
<p class="para"><em class="italic">Color of Ribbon:</em> Red</p>
<p class="centerImage"><img alt="image" id="imgfr36" src="images/imgfr36.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. Alexander of Neva</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof49.vue?344dd551